import firebase from 'firebase/compat/app';
import * as url from "./url_helper";

// Add the Firebase products that you want to use
import "firebase/compat/auth";
import "firebase/compat/firestore";
import { useAPIClient } from './api_helper';
import { S3Client } from './api_helper';
import { toast } from 'react-toastify';
import { fetchUserAttributes } from 'aws-amplify/auth';
import axios from 'axios';



class FirebaseAuthBackend {
  constructor(firebaseConfig) {
    if (firebaseConfig) {
      // Initialize Firebase
      firebase.initializeApp(firebaseConfig);
      firebase.auth().onAuthStateChanged(user => {
        if (user) {
          sessionStorage.setItem("authUser", JSON.stringify(user));
        } else {
          sessionStorage.removeItem("authUser");
        }
      });
    }
  }

  /**
   * Registers the user with given details
   */
  registerUser = (email, password) => {
    return new Promise((resolve, reject) => {
      firebase
        .auth()
        .createUserWithEmailAndPassword(email, password)
        .then(
          user => {
            resolve(firebase.auth().currentUser);
          },
          error => {
            reject(this._handleError(error));
          }
        );
    });
  };

  /**
   * Registers the user with given details
   */
  editProfileAPI = (email, password) => {
    return new Promise((resolve, reject) => {
      firebase
        .auth()
        .createUserWithEmailAndPassword(email, password)
        .then(
          user => {
            resolve(firebase.auth().currentUser);
          },
          error => {
            reject(this._handleError(error));
          }
        );
    });
  };

  /**
   * Login user with given details
   */
  loginUser = (email, password) => {
    return new Promise((resolve, reject) => {
      firebase
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then(
          user => {
            resolve(firebase.auth().currentUser);
          },
          error => {
            reject(this._handleError(error));
          }
        );
    });
  };

  /**
   * forget Password user with given details
   */
  forgetPassword = email => {
    return new Promise((resolve, reject) => {
      firebase
        .auth()
        .sendPasswordResetEmail(email, {
          url:
            window.location.protocol + "//" + window.location.host + "/login",
        })
        .then(() => {
          resolve(true);
        })
        .catch(error => {
          reject(this._handleError(error));
        });
    });
  };

  /**
   * Logout the user
   */
  logout = () => {
    return new Promise((resolve, reject) => {
      firebase
        .auth()
        .signOut()
        .then(() => {
          resolve(true);
        })
        .catch(error => {
          reject(this._handleError(error));
        });
    });
  };

  /**
   * Social Login user with given details
   */
  socialLoginUser = async (type) => {
    let provider;
    if (type === "google") {
      provider = new firebase.auth.GoogleAuthProvider();
    } else if (type === "facebook") {
      provider = new firebase.auth.FacebookAuthProvider();
    }
    try {
      const result = await firebase.auth().signInWithPopup(provider);
      const user = result.user;
      return user;
    } catch (error) {
      throw this._handleError(error);
    }
  };

  addNewUserToFirestore = (user) => {
    const collection = firebase.firestore().collection("users");
    const { profile } = user.additionalUserInfo;
    const details = {
      firstName: profile.given_name ? profile.given_name : profile.first_name,
      lastName: profile.family_name ? profile.family_name : profile.last_name,
      fullName: profile.name,
      email: profile.email,
      picture: profile.picture,
      createdDtm: firebase.firestore.FieldValue.serverTimestamp(),
      lastLoginTime: firebase.firestore.FieldValue.serverTimestamp()
    };
    collection.doc(firebase.auth().currentUser.uid).set(details);
    return { user, details };
  };

  setLoggeedInUser = user => {
    sessionStorage.setItem("authUser", JSON.stringify(user));
  };

  /**
   * Returns the authenticated user
   */
  getAuthenticatedUser = () => {
    if (!sessionStorage.getItem("authUser")) return null;
    return JSON.parse(sessionStorage.getItem("authUser"));
  };

  /**
   * Handle the error
   * @param {*} error
   */
  _handleError(error) {
    // var errorCode = error.code;
    var errorMessage = error.message;
    return errorMessage;
  }
}

let _fireBaseBackend = null;

/**
 * Initilize the backend
 * @param {*} config
 */

const APIClient = useAPIClient()
const initFirebaseBackend = config => {
  if (!_fireBaseBackend) {
    _fireBaseBackend = new FirebaseAuthBackend(config);
  }
  return _fireBaseBackend;
};

/**
 * Returns the firebase backend
 */
const getFirebaseBackend = () => {
  return _fireBaseBackend;
};

//get tenant_id

const getTenant_id = async () => {
  try {
    const token = localStorage.getItem('authUser')
    const tenant_id = localStorage.getItem('tenant_id')
    if (token && !tenant_id) {
      const user = await fetchUserAttributes();
      const tenant_id = user['custom:tenant_id'];
      // sessionStorage.setItem("tenant_id", parseInt(tenant_id));
      return tenant_id;
    } else {
      return tenant_id;
    }
  } catch (error) {
    console.log(error);

  }
}


const PdfSummarizationAPI = {

  // ChatBot
  createChat: async (message, sessionId) => {
    const response = await APIClient.create(`/chatbot`, {
      question: message,
      session_id: sessionId
    });
    return response;
  },
  // Get Presigned URL
  requestPresignedUrl: async (fileName, fileType, fileSiza) => {
    const user = JSON.parse(localStorage.getItem('authUser'));

    const response = await APIClient.create(`/upload-url`, {
      file_name: fileName,
      content_type: fileType,
      user_id: user?.userId,
      // file_size: fileSiza
    });

    return {
      preSignedUrl: response.result.upload_url,
      fileId: response.result.file_key,
      correlationId: response.result?.document_id,
      fileName
    };
  },

  // Upload file to S3 (using pre-signed URL)
  uploadToS3: async (preSignedUrl, file, onUploadProgress) => {
    // const S3Client = axios.create();
    const data = await S3Client.put(preSignedUrl, file, {
      headers: {
        'Content-Type': file.type,
        'Authorization': undefined  // Remove Authorization header
      },
      onUploadProgress
    });

    return {
      fileName: file.name,
      fileSize: (file.size / 1024 / 1024).toFixed(2) + ' MB',
      uploadDate: new Date().toISOString().split('T')[0]
    };
  },

  // Get processing status
  getProcessingStatus: async (correlationId) => {
    const response = await APIClient.get(`/pdf/status/${correlationId}`);
    return {
      status: response.data.status,
      processingStage: response.data.stage,
      correlationId
    };
  },

  // Fetch AI summary
  fetchSummary: async (correlationId) => {
    const user = JSON.parse(localStorage.getItem('authUser'));
    const response = await APIClient.get(`/pdf/summary/${user.userId}/${correlationId}`);
    return {
      summary: response.result,
      correlationId,
      metadata: response.result.metadata
    };
  },

  // Get all uploaded files
  getAllFiles: async (pageSize, offset) => {
    const user = JSON.parse(localStorage.getItem('authUser'));
    const response = await APIClient.get(`/documents/?limit=${pageSize}&offset=${offset}`);
    
    return response.result;
  },

  // Delete file
  deleteFile: async (data) => {
    const user = JSON.parse(localStorage.getItem('authUser'));
    await APIClient.delete(`delete/`,data);
    return { documentId: data.documentId };
  },

  // Download file
  downloadFile: async (fileId) => {
    const response = await APIClient.get(`/pdf/download/${fileId}`, {
      responseType: 'blob'
    });
    return response.data;
  },

  // Get download URL (alternative approach)
  getDownloadUrl: async (fileId) => {
    const response = await APIClient.get(`/pdf/download-url/${fileId}`);
    return response.data.downloadUrl;
  }
};



export { initFirebaseBackend, getFirebaseBackend, getTenant_id, PdfSummarizationAPI };